import './VerifiedDemoAccountViewer.scss';
import { CustomerSupportLink } from '@/components/CustomerSupportLink';
import { useAccountService } from '@/hooks/useAccountService';
import { ByzzerButton } from '@byzzer/ui-components';
import { ByzzerLink } from '@/components/form';
import { TenantUser } from '@/types/ApiTypes';

type VerifiedDemoAccountViewerProps = {
    user?: TenantUser;
};

const baseClassName = 'verified-demo-account-viewer';

export function VerifiedDemoAccountViewer(props: VerifiedDemoAccountViewerProps) {
    const { user } = props;
    const { logout } = useAccountService();

    return (
        <div className={`${baseClassName}`}>
            <div className={`${baseClassName}__logo`}>
                <div className={`${baseClassName}__logo-image`} />
                <div className={`${baseClassName}__logo-text`}>Byzzer</div>
            </div>
            <div className={`${baseClassName}__content`}>
                <h1 className={`${baseClassName}__title`}>Verify your account</h1>
                <p>
                    Your verification email for <ByzzerLink>{user?.email}</ByzzerLink> should arrive in the next 5
                    minutes - be sure to check the spam folder.
                </p>
                <p>
                    Not seeing the email, or ready to finish signing up now? Send us a chat or contact us at{' '}
                    {/* @ts-ignore */}
                    <CustomerSupportLink />.
                </p>
                <p>Not the correct demo account? Logout below.</p>
            </div>
            <div className={`${baseClassName}__logout-button`}>
                <ByzzerButton onClick={logout} label={'Logout'}></ByzzerButton>
            </div>
        </div>
    );
}
